import { useEffect, useState } from 'react';
import PlanetToolbar from './PlanetToolbar';
import PlanetEditor from 'scripts/scenes/planet-editor';
import Engine from 'scripts/engine/engine';
import geoTemplates from 'scripts/objects/geo-planet/templates';

function GeoPlanetViewer() {
    const [scene, setScene] = useState<PlanetEditor>();

    useEffect(() => {
        const newScene = new PlanetEditor();
        const planetData = localStorage.getItem("icoPlanetData") || geoTemplates.default;
        newScene.loadData(planetData, true);
        setScene(newScene);
        Engine.instance.curtain.fadeIn(1.0);

        return () => {
            if(newScene) {
                newScene.dispose();
            }
        }
    }, [])

    return (
        <div id="planet-viewer-component">
            {scene && <PlanetToolbar editor={scene}/>}
        </div>
    );
}

export default GeoPlanetViewer;
